/** A plain CSS phone frame around a real app screenshot — no illustration, the actual product. */
export function PhoneMockup({ src, className }: { src: string; className?: string }) {
  return (
    <div className={className}>
      <div className="relative mx-auto w-[260px] sm:w-[290px] aspect-[9/19.5] rounded-[2.5rem] border-[6px] border-[#1c1526] bg-[#1c1526] shadow-2xl shadow-black/60">
        <div className="relative w-full h-full rounded-[2rem] overflow-hidden bg-canvas">
          <img src={src} alt="Drameeka app — watching THE RED HEEL" className="w-full h-full object-cover" />
        </div>
        {/* Dynamic-island-style notch */}
        <div className="absolute top-2 left-1/2 -translate-x-1/2 w-20 h-5 rounded-full bg-[#1c1526]" />
      </div>
    </div>
  );
}
